import { ReactNode } from 'react'

import { Form } from 'factorial-form'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { formGetDirtyFields } from 'modules/core/lib/formGetDirtyFields'

import ContractFlowStep from 'modules/contracts/lib/ContractFlowStep'

class RequestPromoteFlowStep extends ContractFlowStep {
  constructor(title: string, component: ReactNode, description?: string) {
    super(title, component, description)
  }

  trackNext(form: Form, step: number): void {
    track(trackingEvents.employee.contracts.requestPromoteContractNext, {
      step: step,
      fields_edited: formGetDirtyFields(form),
      fields_completed: form.fieldsWithValueKeys,
      approval: true,
      promotion_details: form.get('request_details').value,
    })
  }

  trackBack(form: Form, step: number): void {
    track(trackingEvents.employee.contracts.requestPromoteContractBack, {
      step: step,
      fields_edited: formGetDirtyFields(form),
      fields_completed: form.fieldsWithValueKeys,
    })
  }

  trackSubmit(form: Form): void {
    track(trackingEvents.employee.contracts.requestPromoteContractSubmit, {
      fields_edited: formGetDirtyFields(form),
      fields_completed: form.fieldsWithValueKeys,
      approval: true,
    })
  }

  trackExit(step: number): void {
    track(trackingEvents.employee.contracts.requestPromoteContractExit, {
      step: step,
    })
  }
}

export default RequestPromoteFlowStep
